import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import heroWatermark from "@/assets/hero-brand-watermark.webp.asset.json";

const HeroSection = () => {
  return (
    <section id="start" className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/hero-building.webp"
          srcSet="/hero-building-640.webp 640w, /hero-building-828.webp 828w, /hero-building-1280.webp 1280w, /hero-building.webp 1920w"
          sizes="100vw"
          alt="Smart Building"
          className="w-full h-full object-cover"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-hero-overlay/85" />
      </div>

      <img
        src={heroWatermark.url}
        alt=""
        aria-hidden="true"
        decoding="async"
        className="hero-brand-watermark pointer-events-none absolute bottom-8 -right-14 w-28 max-w-none select-none md:bottom-12 md:-right-24 md:w-48"
      />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-2xl"
        >
          <p className="text-secondary-bright font-semibold text-[0.7rem] md:text-sm tracking-widest uppercase mb-4">
            IT · OT · Gebäudeautomation · Security
          </p>
          <h1 className="font-display text-[2rem] sm:text-5xl md:text-6xl font-bold text-primary-foreground leading-[1.05] mb-6 uppercase">
            Fachsprech
            <span className="text-secondary-bright">partner</span>
            <span className="sr-only"> – Beratung für OT-Security und Gebäudeautomation</span>
          </h1>
          <p className="text-primary-foreground/85 text-base md:text-xl leading-relaxed mb-6 md:mb-8 max-w-xl">
            Ich vertrete das Facility Management, Gebäudebetreiber und unterstütze GA-Fachplaner – damit Smart Buildings auch smart bleiben.
          </p>
          <p className="text-primary-foreground/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Planung und Beratung von und zu IT/OT-Infrastrukturen nach <span className="text-secondary-bright font-semibold whitespace-nowrap">IEC&nbsp;62443</span>: von OT-Organisation und Assetmanagement über OT-Netzwerk Architekturen bis zu den Endpoints, für den verlässlichen Betrieb von Gebäuden, Produktion und Industrie.
          </p>
          <div className="flex flex-nowrap items-center gap-2 sm:gap-3">
            <a
              href="#about"
              className="inline-flex items-center gap-2 bg-secondary-bright text-secondary-bright-foreground px-4 py-2.5 rounded-md font-semibold text-xs sm:text-sm tracking-wide whitespace-nowrap transition-all duration-200 ease-out hover:bg-secondary-bright/90 hover:-translate-y-0.5 hover:shadow-md hover:shadow-secondary-bright/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-bright focus-visible:ring-offset-2 focus-visible:ring-offset-hero-overlay active:translate-y-0 active:scale-[0.97] active:bg-secondary-bright/80"
            >
              Mehr erfahren
            </a>
            <button
              type="button"
              onClick={() =>
                window.dispatchEvent(new CustomEvent("open-contact-form"))
              }
              className="inline-flex items-center gap-2 bg-cta-hover text-cta-foreground px-4 py-2.5 rounded-md font-extrabold text-xs sm:text-sm uppercase tracking-[0.12em] shadow-md shadow-cta/40 whitespace-nowrap transition-all duration-200 ease-out hover:brightness-90 hover:shadow-lg hover:shadow-cta/50 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-bright focus-visible:ring-offset-2 focus-visible:ring-offset-hero-overlay focus-visible:brightness-95 active:translate-y-0 active:scale-[0.97] active:brightness-75 active:shadow-md"
            >
              Jetzt starten
              <ArrowRight size={14} strokeWidth={3} className="-mr-0.5" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
